import BreadCrumb from "Components/Common/BreadCrumb"
import { AccountsPage } from "features/accounts"
import { Container } from "reactstrap"

const Accounts = () => {
  return (
    <div className="page-content">
      <Container fluid>
          <BreadCrumb title={"Accounts"} pageTitle={"Modules"} />
          <AccountsPage />
        </Container>
      
    </div>
  )
}
export default Accounts